export const FOOTER_BLOCK_s8 = {
  "blockType": "FOOTER",
  "blockDesign": "FooterDesign2",
  "editFormName": "FOOTER_FORM_2",
  "styleProps": {
    "background-color": "#060F11",
    "padding": "50px 50px 50px 50px",
    "color": "#ffffff"
  },
  "metaDataId": 1746356182317,
  "company": {
    "description": {
      "list": [
        "Navdic 2023. All rights reserved."
      ]
    },
    "name": {
      "text": "☕︎ Codic",
      "styleProps": {
        "color": "#ffffff",
        "font-size": "2.25rem",
        "line-height": "2.5rem",
        "margin": "0px 0px 20px 0px",
        "font-weight": "700"
      }
    },
    "copy": {
      "text": "Transforming Businesses with Innovative Software Solutions",
      "styleProps": {
        "margin": "120px 0px 60px 0px",
        "color": "#ffffff",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "font-weight": "500",
        "font-family-cust": "",
        "font-family": ""
      },
      "stylePropsTab": {
        "margin": "80px 0px 120px 0px"
      },
      "stylePropsMob": {
        "margin": "60px 0px 60px 0px"
      }
    },
    "styleProps": {
      "width": "100%",
      "background-color": "",
      "padding": "20px 20px 20px 20px",
      "color": "#808080",
      "font-family-cust": "Cascadia Code",
      "font-family": "'Cascadia Code'",
      "font-size": "1.125rem",
      "line-height": "1.75rem"
    },
    "logo": {
      "text": ""
    }
  },
  "column1": {
    "links": [
      {
        "label": {
          "text": "About",
          "styleProps": {
            "font-size": "1.125rem",
            "line-height": "1.75rem",
            "color": "#B5BDBA",
            "padding-bottom": "10px",
            "display": "inline-block",
            "padding": "0px 0px 10px 0px",
            "font-family-cust": "Cascadia Code",
            "font-family": "'Cascadia Code'"
          },
          "stylePropsTab": {
            "font-size": "1.5rem",
            "line-height": "2rem"
          }
        },
        "url": "#about"
      },
      {
        "label": {
          "text": "Products",
          "styleProps": {
            "color": "#B5BDBA",
            "padding-left": "10px",
            "padding": "0px 0px 10px 0px",
            "font-size": "1.125rem",
            "font-family-cust": "Cascadia Code",
            "font-family": "'Cascadia Code'",
            "line-height": "1.75rem"
          }
        },
        "url": "#products"
      },
      {
        "label": {
          "text": "Services",
          "styleProps": {
            "color": "#B5BDBA",
            "padding": "0px 0px 10px 0px",
            "margin": "0px 0px 0px 0px",
            "font-family-cust": "Cascadia Code",
            "font-family": "'Cascadia Code'",
            "font-size": "1.125rem",
            "line-height": "1.75rem"
          }
        },
        "url": "fasty"
      }
    ],
    "title": {
      "text": "COMPANY",
      "styleProps": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 20px 0px",
        "color": "#ffffff",
        "font-weight": "600",
        "letter-spacing": "0.1em",
        "font-family-cust": "Cascadia Code",
        "font-family": "'Cascadia Code'"
      }
    },
    "styleProps": {
      "width": "none",
      "color": "#cccccc",
      "background-color": "",
      "border-radius": "0px",
      "padding": "20px 20px 20px 20px"
    }
  },
  "column2": {
    "links": [
      {
        "label": {
          "text": "hello@promosite.com",
          "styleProps": {
            "font-size": "1.125rem",
            "line-height": "1.75rem",
            "color": "#B5BDBA",
            "padding": "0px 0px 10px 0px",
            "font-family-cust": "Cascadia Code",
            "font-family": "'Cascadia Code'"
          }
        },
        "url": "fasty"
      },
      {
        "label": {
          "text": "careers@promosite.com",
          "styleProps": {
            "color": "#B5BDBA",
            "padding": "0px 0px 10px 0px",
            "font-family-cust": "Cascadia Code",
            "font-family": "'Cascadia Code'",
            "font-size": "1.125rem",
            "line-height": "1.75rem"
          }
        },
        "url": "fasty"
      }
    ],
    "title": {
      "text": "GET IN TOUCH",
      "styleProps": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 20px 0px",
        "color": "#ffffff",
        "font-weight": "600",
        "letter-spacing": "0.1em",
        "font-family-cust": "Cascadia Code",
        "font-family": "'Cascadia Code'"
      }
    },
    "styleProps": {
      "background-color": "",
      "width": "100%",
      "padding": "20px 20px 20px 20px"
    }
  },
  "column4": {
    "title": {
      "text": "CONNECT",
      "styleProps": {
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "margin": "0px 0px 20px 0px",
        "color": "#ffffff",
        "font-weight": "600",
        "font-family-cust": "Cascadia Code",
        "font-family": "'Cascadia Code'",
        "letter-spacing": "0.1em"
      }
    },
    "links": [
      {
        "label": {
          "text": "Facebook",
          "styleProps": {
            "padding": "0px 0px 0px 0px",
            "margin": "0px 0px 0px 0px",
            "color": "#333333"
          }
        },
        "url": "http://facebook.com/promosite",
        "image": {
          "text": "https://d11lx8wl9i3fvs.cloudfront.net/1648919366374/1676180930331.png",
          "styleProps": {
            "padding": "0px 0px 0px 0px",
            "margin": "0px 10px 0px 0px",
            "opacity": "0.7"
          }
        }
      },
      {
        "label": {
          "text": "Twitter"
        },
        "url": "http://twitter.com/promosite",
        "image": {
          "text": "https://d11lx8wl9i3fvs.cloudfront.net/1648919366374/1676180951924.png",
          "styleProps": {
            "margin": "0px 10px 0px 0px",
            "opacity": "0.7"
          }
        }
      },
      {
        "label": {
          "text": "Pinterest",
          "styleProps": {
            "padding": "0px 0px 0px 0px"
          }
        },
        "url": "",
        "image": {
          "text": "https://d11lx8wl9i3fvs.cloudfront.net/1648919366374/1676181521667.png",
          "styleProps": {
            "opacity": "0.7"
          }
        }
      }
    ],
    "styleProps": {
      "background-color": "",
      "padding": "20px 20px 20px 20px"
    },
    "type": "only_icon"
  },
  "bottom_links": {
    "links": [
      {
        "label": {
          "text": "Terms & Conditions",
          "styleProps": {
            "font-size": "1rem",
            "line-height": "1.5rem",
            "color": "#808080"
          }
        },
        "url": ""
      },
      {
        "label": {
          "text": "Privacy Policy",
          "styleProps": {
            "color": "#808080"
          }
        },
        "url": ""
      },
      {
        "label": {
          "text": "Disclaimer",
          "styleProps": {
            "color": "#808080"
          }
        },
        "url": ""
      }
    ],
    "styleProps": {
      "padding": "50px 0px 50px 0px",
      "background-color": "",
      "font-size": "1.125rem",
      "line-height": "1.75rem",
      "color": "#ffffff",
      "margin": "120px 0px 0px 0px",
      "font-family-cust": "Cascadia Code",
      "font-family": "'Cascadia Code'"
    }
  },
  "afterIndex": 28,
  "blockId": 1746356182317,
  "fonts": {
    "column1": "Cascadia Code",
    "column2": "Cascadia Code",
    "column4": "Cascadia Code",
    "company": "",
    "bottom_links": "Cascadia Code"
  }
}